import {useQuery} from "@tanstack/react-query";
import {getSentNotificationSentDetails} from "../apis/messageListApi";

export const useSentMessageDetailsCache = (messageId: string | undefined) => {

    const {data: sentDetails, isLoading} = useQuery({
        queryKey: ["sentMessageDetails", messageId],
        queryFn: () => getSentNotificationSentDetails(messageId!),
        enabled: !!messageId,
        staleTime: Infinity,
    });

    return {
        sentDetails,
        isLoading,
    }
}